import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { SvgIcon } from '@material-ui/core';
import TotalDebt from '../../icons/totalDebt.svg';
import LifeStage from '../../icons/lifeStage.svg';
import InsuranceNeed from '../../icons/insuranceNeed.svg';
import TotalAssets from '../../icons/totalAssets.svg';
import TotalIncome from '../../icons/totalIncome.svg';
import CurrentCoverage from '../../icons/currentCoverage.svg';
import { makeStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';
import Age from '../Helpers/Dates/Age';

const useStyles = makeStyles(theme => ({
  primaryText: {
    color: theme.palette.primary.main,
  }
}));

export default function BasicDetails(props) {
  const classes = useStyles();

  const allFormState = props.fullFormState && props.fullFormState.pages;

  const basicInfoState = allFormState && props.fullFormState.pages.clientBasicInfo;
  const age = Age(basicInfoState.clientBirthdate);
  const gender = basicInfoState.clientGender;
  const maritalStatus = basicInfoState.maritalStatus;
  const residentState = basicInfoState.clientState;

  const financialInfoState = allFormState && props.fullFormState.pages.financialInfo;
  const totalDebt = financialInfoState.debt;

  const currentInsuranceState = allFormState && props.fullFormState.pages.currentInsurance;
  const hasCurrentInsuranceState = currentInsuranceState.hasExistingDIPolicy !== '' || currentInsuranceState.hasExistingPolicy !== '' || currentInsuranceState.hasExistingLTCPolicy !== '';
  const existingLifePolicyCoverage = currentInsuranceState.hasExistingPolicy === 'yes' ? Number(currentInsuranceState.existingLifePolicyCoverage) : 0;
  const existingDIPolicyCoverage = currentInsuranceState.hasExistingDIPolicy === 'yes' ? Number(currentInsuranceState.existingDIPolicyCoverage) : 0;
  const existingLTCPolicyCoverage = currentInsuranceState.hasExistingLTCPolicy === 'yes' ? Number(currentInsuranceState.existingLTCPolicyCoverage) : 0;

  const annualIncome = Number(financialInfoState.mainIncome) || 0;
  const spouseIncome = Number(financialInfoState.spouseIncome) || 0;
  const otherIncome = Number(financialInfoState.otherIncome) || 0;

  const liquidAssets = Number(financialInfoState.liquidAssets) || 0;
  const retirementAssets = Number(financialInfoState.retirementAssets) || 0;
  const otherAssets = Number(financialInfoState.otherAssets) || 0;

  const financialIncome = () => {
    const netIncome = (annualIncome + otherIncome + spouseIncome);
    return netIncome;
  }

  const financialAssets = () => {
    const netAssets = (liquidAssets + retirementAssets + otherAssets);
    return netAssets;
  }

  const totalIncome = (financialInfoState.annualIncome || financialInfoState.spouseIncome || financialInfoState.otherIncome) ? financialIncome() : '';
  const totalAssets = (financialInfoState.liquidAssets || financialInfoState.retirementAssets || financialInfoState.otherAssets) ? financialAssets() : '';

  return (
    <Container fluid className="px-0">
      <Row className="basic-details text-center">
        <Col md={2}>
          <div className="details" id='personal-info-details' name='personal-info-details'>
            <SvgIcon component={LifeStage} color="primary" className="small-icons" fontSize="large" id='personal-info-icon' name='personal-info-icon' />
            <h6 className={`${classes.primaryText}  py-2 `} id='personal-info-header' name='personal-info-header'>Personal Information</h6>
            <Row>
              <Col md={7} className="px-0">
                <h6 className="info-first text-left" id='personal-info-age' name='personal-info-age'>
                  <b>{age && age !== 'Invalid date' ? `${parseInt(age, 10)} years old` : ''}</b>
                </h6>
              </Col>
              <Col md={5} className="px-0">
                <h6 className='text-left ml-3' id='personal-info-marital-status' name='personal-info-marital-status'>
                  <b>{maritalStatus ? maritalStatus === 'Single' ? 'Single' : 'Married' : ''}</b>
                </h6>
              </Col>
            </Row>

            <Row>
              <Col md={7} className="px-0">
                <h6 className="info-first text-left" id='personal-info-gender' name='personal-info-gender'>
                  <b>{gender ? gender === 'M' ? 'Male' : 'Female' : ''}</b>
                </h6>
              </Col>
              <Col md={5} className="px-0">
                <h6 className='text-left ml-3' id='personal-info-state' name='personal-info-state'>
                  <b>{residentState}</b>
                </h6>
              </Col>
            </Row>
          </div>
        </Col>
        <Col md={2}>
          <div className="details" id='total-income-details' name='total-income-details'>
            {totalIncome !== '' && (
              <div id='total-income-info' name='total-income-info'>
                <SvgIcon component={TotalIncome} color="primary" className="small-icons" fontSize="large"  id='total-income-icon' name='total-income-icon'/>
                <h6 className={`${classes.primaryText}  py-2 `} id='total-income-header' name='total-income-header'>Total Income</h6>
                <h6 id='total-income-amount-text' name='total-income-amount-text'>
                  <b><span id='total-income-amount-info' name='total-income-amount-info'><NumberFormat displayType={'text'} prefix={'$'} value={totalIncome} thousandSeparator={true}  id='total-income-amount' name='total-income-amount'/><span id='total-income-amount-per-year' name='total-income-amount-per-year'>/year</span></span></b>
                </h6>
              </div>
            )}
          </div>
        </Col>

        <Col md={2}>
          <div className="details" id='total-assets-details' name='total-assets-details'>
            {totalAssets !== '' && (
              <div id='total-assets-info' name='total-assets-info'>
                <SvgIcon component={TotalAssets} color="primary" className="small-icons" fontSize="large"  id='total-assets-icon' name='total-assets-icon'/>
                <h6 className={`${classes.primaryText}  py-2 `} id='total-assets-header' name='total-assets-header'>Total Assets</h6>
                <h6 id='total-assets-amount-text' name='total-assets-amount-text'>
                  <b><NumberFormat displayType={'text'} prefix={'$'} value={totalAssets} thousandSeparator={true} id='total-assets-amount' name='total-assets-amount'/></b>
                </h6>
              </div>
            )}
          </div>
        </Col>

        <Col md={2}>
          <div className="details" id='total-debt-details' name='total-debt-details'>
            {totalDebt !== '' && (
              <div id='total-debt-info' name='total-debt-info'>
                <SvgIcon component={TotalDebt} color="primary" className="small-icons" fontSize="large"  id='total-debt-icon' name='total-debt-icon'/>
                <h6 className={`${classes.primaryText}  py-2 `} id='total-debt-header' name='total-debt-header'>Total Debt</h6>
                <h6 id='total-debt-amount-text' name='total-debt-amount-text'>
                  <b><NumberFormat displayType={'text'} prefix={'$'} value={totalDebt} thousandSeparator={true} id='total-debt-amount' name='total-debt-amount'/></b>
                </h6>
              </div>
            )}
          </div>
        </Col>

        <Col md={2}>
          <div className="details" id='current-coverage-details' name='current-coverage-details'>
            {hasCurrentInsuranceState && (
              <div id='current-coverage-info' name='current-coverage-info'>
                <SvgIcon component={CurrentCoverage} color="primary" className="small-icons" fontSize="large" id='current-coverage-icon' name='current-coverage-icon' />
                <h6 className={`${classes.primaryText}  py-2 `} id='current-coverage-header' name='current-coverage-header'>Current Coverage</h6>
                <h6 id='current-coverage-amount-text' name='current-coverage-amount-text'>
                  <b><NumberFormat displayType={'text'} prefix={'$'} value={existingLifePolicyCoverage} thousandSeparator={true} id='current-coverage-amount' name='current-coverage-amount' /></b>
                </h6>
                <h6 id='current-coverage-amount-per-month' name='current-coverage-amount-per-month'>
                  <b><NumberFormat displayType={'text'} prefix={'$'} value={existingDIPolicyCoverage + existingLTCPolicyCoverage} thousandSeparator={true} id='monthly-coverage-amount' name='monthly-coverage-amount' />/month</b>
                </h6>
              </div>
            )}
          </div>
        </Col>
        <Col md={2}>
          {
            props.isQuoterPage && (
              <div className="details-last" id='insurance-need-details' name='insurance-need-details'>
                <SvgIcon component={InsuranceNeed} color="primary" className="small-icons" fontSize="large"  id='insurance-need-icon' name='insurance-need-icon'/>
                <h6 className={`${classes.primaryText}  py-2  mb-0`} id='insurance-need-header' name='insurance-need-header'>Insurance Need</h6>
                <h6 id='insurance-need-amount-text' name='insurance-need-amount-text'>
                  <b><NumberFormat displayType={'text'} prefix={'$'} value={allFormState.quoter.needsCoverageAmount} thousandSeparator={true} id='insurance-need-amount' name='insurance-need-amount'/></b>
                </h6>
                <h6 id='insurance-need-amount-per-month' name='insurance-need-amount-per-month'>
                  <b>Approx $60-$80/month</b>
                </h6>
              </div>
            )
          }
        
        </Col>
      </Row>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/BasicDetails.js